var render, staticRenderFns
import script from "./DownloadButton.vue?vue&type=script&lang=js&"
export * from "./DownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DownloadButton.vue"
export default component.exports